import { CircularProgress, MenuItem } from "@mui/material"


export const LoadingFilter = () => {
    return (
        <MenuItem className="flex items-center justify-center" disabled>
            <CircularProgress className="mx-auto" size={24} />
        </MenuItem>
    )
}
